module.exports = __webpack_public_path__ + "img/wheel_loader.bcc4e82a.png";